import { memo } from "react";
import * as Styled from "./style";
import type { G_GetVideoMainEpisodeQuery } from "~/lib/graphql";

export type DetailPriceTextProps = {
  // TODO 型定義の方法がだめ。GetVideoMainEpisodeQueryとGetVideoからppvProductsがやってくる。
  // 次回PRで修正
  ppvProducts: G_GetVideoMainEpisodeQuery["video"]["episodes"]["edges"][number]["node"]["ppvProducts"];
};

/**
 * ### PPV価格表記パターンの出し分けを行うコンポーネント
 */
export const DetailPriceText = memo((props: DetailPriceTextProps) => {
  const { ppvProducts = [] } = props;

  if (ppvProducts.length === 0) return null;

  const isSinglePrice = ppvProducts.length === 1 && ppvProducts.every(({ price }) => price.price === price.salePrice);
  const isMultiPrice = ppvProducts.length > 1 && ppvProducts.every(({ price }) => price.price === price.salePrice);
  const isSingleSalePrice = ppvProducts.length === 1 && ppvProducts.every(({ price }) => price.price > price.salePrice);
  const isMultiSalePrice = ppvProducts.length > 1 && ppvProducts.some(({ price }) => price.price > price.salePrice);

  return (
    <Styled.DivWrapper>
      {(() => {
        if (isMultiSalePrice) {
          const { price, salePrice } = [...ppvProducts].sort((a, b) => a.price.salePrice - b.price.salePrice)[0].price;

          return (
            <>
              <Styled.SpanOriginPrice>{price.toLocaleString()}円</Styled.SpanOriginPrice>
              <Styled.SpanText>{salePrice.toLocaleString()}円〜</Styled.SpanText>
            </>
          );
        }

        if (isSingleSalePrice) {
          const { price, salePrice } = ppvProducts[0].price;

          return (
            <>
              <Styled.SpanOriginPrice>{price.toLocaleString()}円</Styled.SpanOriginPrice>
              <Styled.SpanText>{salePrice.toLocaleString()}円</Styled.SpanText>
            </>
          );
        }

        if (isMultiPrice) {
          const { salePrice } = [...ppvProducts].sort((a, b) => a.price.salePrice - b.price.salePrice)[0].price;
          return <Styled.SpanText>{salePrice.toLocaleString()}円〜</Styled.SpanText>;
        }

        if (isSinglePrice) {
          const { salePrice } = ppvProducts[0].price;
          return <Styled.SpanText>{salePrice.toLocaleString()}円</Styled.SpanText>;
        }

        return null;
      })()}
    </Styled.DivWrapper>
  );
});

DetailPriceText.displayName = "PriceText";
